import {
  STORE_INCOMING_ACCESS_REQUESTS,
  STORE_OUTGOING_ACCESS_REQUESTS,
  STORE_PENDING_ACCESS_FOR_USERS,
} from '../../constants/accessRequests';

const initialState = {
  // Asks aimed at the location currently being managed.
  incomingPending: [],
  // Everything already decided there — the APPROVED rows are what the
  // Revoke action operates on, so this is not just history.
  incomingDecided: [],
  // Asks this company has raised elsewhere.
  outgoingPending: [],
  outgoingDecided: [],
  // Outstanding asks keyed by employee, for the wizard's chips.
  pendingForUsers: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_INCOMING_ACCESS_REQUESTS:
      return {
        ...state,
        incomingPending: action.pending || [],
        incomingDecided: action.decided || [],
      };
    case STORE_OUTGOING_ACCESS_REQUESTS:
      return {
        ...state,
        outgoingPending: action.pending || [],
        outgoingDecided: action.decided || [],
      };
    case STORE_PENDING_ACCESS_FOR_USERS:
      return {
        ...state,
        pendingForUsers: action.requests || [],
      };
    default:
      return state;
  }
};
